import { axiosInstance } from "./";

export const getRegisteredUserList = async (params) => {
  return await axiosInstance.get(`users`, {
    params
  });
};
